<label class="address-label" *ngIf="props.label">
    {{ getLabel() | htmlDecode }}
    <span class="required-color" *ngIf="props.required">*</span>
</label>
<ng-container #fieldComponent></ng-container>